module.exports = __webpack_public_path__ + "static/media/casa-kaoba.1a31e2be.png";